var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07143 5.5102H28.9286C29.5203 5.5102 30 4.96202 30 4.28571V1.22449C30 0.548189 29.5203 0 28.9286 0H1.07143C0.479665 0 0 0.548189 0 1.22449V4.28571C0 4.96202 0.479665 5.5102 1.07143 5.5102ZM1.07143 17.7551H28.9286C29.5203 17.7551 30 17.2069 30 16.5306V13.4694C30 12.7931 29.5203 12.2449 28.9286 12.2449H1.07143C0.479665 12.2449 0 12.7931 0 13.4694V16.5306C0 17.2069 0.479665 17.7551 1.07143 17.7551ZM1.07143 30H28.9286C29.5203 30 30 29.4518 30 28.7755V25.7143C30 25.038 29.5203 24.4898 28.9286 24.4898H1.07143C0.479665 24.4898 0 25.038 0 25.7143V28.7755C0 29.4518 0.479665 30 1.07143 30Z",
    fill: "#112C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.a15467fca735c9a9e242b5098575413c.svg";
export { ForwardRef as ReactComponent };